import * as React from 'react'
import I18n from '../../../../core/i18n'
import { reservationService } from '../../../../core/services'
import { InputText } from '../../../atoms'
import { Form } from 'components/molecules'

import * as interfaces from '../../../../static/interfaces'
import WithLabel from 'components/atoms/WithLabel'
declare var window: interfaces.IWindow

interface IProps {
  tourReservation: any
  formRef: React.MutableRefObject<any>
}
const sendCancelApplication = async (values, tourReservationId) => {
  const params = { ...values, tour_reservation_id: tourReservationId }
  try {
    const { cancel_application, flush } = await reservationService.createCancelApplication(params)

    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    window.location.reload()
  } catch (error) {
    console.error(error)
  }
}
const FIELDS = {
  amount: 'amount',
}

const CancelApplicationModalBody: React.FC<IProps> = props => {
  const [cancelErrors, setCancelErrors] = React.useState<{ reason: null | string }>({
    reason: null,
  })
  return (
    <div style={{ width: '600px' }}>
      <Form
        ref={props.formRef}
        fields={FIELDS}
        handleUpdateForm={(updatedErrors, isSubmitEnabled) => setCancelErrors(updatedErrors)}
        handleSubmit={(initialValues, values) =>
          sendCancelApplication(values, props.tourReservation.id)
        }
      >
        <WithLabel label={I18n.t('generic.refund_amount')}>
          <InputText name="amount" defaultValue={props.tourReservation.default_refund_amount} />
          <small style={{ marginTop: '6px' }}>
            最大返金可能金額は<b>{props.tourReservation.reservable.charge_price}</b>円です。
          </small>
        </WithLabel>
      </Form>
    </div>
  )
}

export const showCancelApplicationModal = async (
  tourReservation: any,
  formRef: React.MutableRefObject<any>
) => {
  window.globalModal.showModal({
    title: I18n.t('activerecord.models.cancel_application'),
    body: <CancelApplicationModalBody tourReservation={tourReservation} formRef={formRef} />,
    closeText: I18n.t('generic.close'),
    submitText: I18n.t('generic.send'),
    handleSubmit: () => {
      formRef.current.handleFormSubmit()
    },
  })
}
